exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mdl-tabs mdl-tab-panel.grid-tab.mdl-tabs__panel.is-active {\n  display: flex;\n  flex-grow: 1;\n}\n\nunit-selector {\n  position: absolute;\n  right: 0;\n}\n\ncovance-filter {\n  flex-shrink: 0;\n}\n\n", ""]);

// exports
